import React from 'react';
import Help from './help/Help';
import Recent from './Recent';
import Notification from './Notification';

const components = [<Recent />, <Notification />, <Help />];

class MenuItems extends React.Component {
    buildItems() {
        return (
			components.map((component, key) => {
				return (
					<li key={key} className="treeview">
						{component}
					</li>
				);
			})
		);
    }

    render() {
        return (
            <ul className="sidebar-menu tree" data-widget="tree">
                {this.buildItems()}
            </ul>
        );
    }
}

export default MenuItems;



// WEBPACK FOOTER //
// ./src/layouts/main/sidebar/MenuItems.js